import { Skeleton, Typography } from '@mui/material';
import Icon, { ColorVariant, SizeVariant } from '@apigrowfinance/pbolt-icon';
import PageHeader from '@apigrowfinance/pbolt-page-header';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';
import { RiAccountCircleLine } from 'react-icons/ri';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import AccountStatus from '@pages/accountContainer/AccountStatus';

type AccountOverviewHeaderProps = {
    name: string;
    email: string;
    isLoading?: boolean;
};

const AccountContainerHeader = ({
    name,
    email,
    isLoading = false,
}: AccountOverviewHeaderProps) => {
    const { theme } = useTheme();
    const navigate = useNavigate();

    const handleOnClick = () => {
        navigate('detail');
    };

    return (
        <PageHeader
            icon={
                <Icon
                    sizeVariant={SizeVariant.Large}
                    colorVariant={ColorVariant.PaperSecondary}
                    data-testid="avatar"
                    avatarProps={{
                        sx: {
                            border: `${theme.spacing(0.125)} solid ${
                                theme.palette.grey[200]
                            };`,
                        },
                    }}
                    isLoading={isLoading}>
                    <RiAccountCircleLine />
                </Icon>
            }
            title={
                <Typography
                    variant="h2"
                    sx={{
                        color: theme?.custom?.brand?.textMain || 'text.primary',
                    }}
                    data-testid="name">
                    {isLoading ? (
                        <Skeleton width={120} data-testid="name-loader" />
                    ) : (
                        name
                    )}
                </Typography>
            }
            description={
                <Typography
                    variant="subtitle2"
                    data-testid="email"
                    color="text.primary">
                    {isLoading ? (
                        <Skeleton width={160} data-testid="email-loader" />
                    ) : (
                        email
                    )}
                </Typography>
            }
            headerOnClick={handleOnClick}
            rightArrowText={
                <FormattedMessage
                    id="AccountContainerHeader.viewProfile"
                    defaultMessage="View profile"
                />
            }
            isLoading={isLoading}
            actions={<AccountStatus />}
        />
    );
};

export default AccountContainerHeader;
